import React, { Component } from "react";
import Select from "react-select";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#505050",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class ReportTwo extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset className="col-md-12">
            <legend>DATOS</legend>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="principio_activo">
                    Principio Activo: <span className="text-danger"> *</span>
                  </label>
                  <Select
                    id="principio_activo"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    isClearable={false}
                    onChange={this.props.handleActividadChange}
                    theme="neutral40"
                    // value={
                    //   this.props.state.actividad !== null
                    //     ? this.props.state.actividad
                    //     : { label: "Seleccione", key: "0" }
                    // }
                    // options={this.props.state.cat_actividad}
                    // getOptionLabel={(actividad) =>
                    //   actividad.descripcion
                    //     ? actividad.descripcion.toUpperCase()
                    //     : null
                    // }
                    // getOptionValue={(actividad) => actividad.id}
                    noOptionsMessage={() =>
                      "No se encontraron principios activos"
                    }
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="principio_Activo-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="despacho">
                    Despacho: <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    name="despacho"
                    id="despacho"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.despacho}
                    className="form-control"
                    placeholder="Ingrese despacho"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="despacho-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-8">
                <div className="form-group">
                  <label htmlFor="ingreso_unidades">
                    Ingreso unidades: <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    name="ingreso_unidades"
                    id="ingreso_unidades"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.ingreso_unidades}
                    className="form-control"
                    placeholder="Ingrese unidades"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="ingreso_unidades-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label htmlFor="gramos_calculados_ingreso">
                    Gramos calculados ingreso:{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    name="gramos_calculados_ingreso"
                    id="gramos_calculados_ingreso"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.gramos_calculados_ingreso}
                    className="form-control"
                    placeholder="Gramos calculados ingreso"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="gramos_calculados_ingreso-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-8">
                <div className="form-group">
                  <label htmlFor="deterioro_unidades">
                    Deterioro unidades: <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    name="deterioro_unidades"
                    id="deterioro_unidades"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.deterioro_unidades}
                    className="form-control"
                    placeholder="Ingrese deterioro unidades"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="deterioro_unidades-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label htmlFor="gramos_calculados_deterioro">
                    Gramos calculados deterioro:{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    name="gramos_calculados_deterioro"
                    id="gramos_calculados_deterioro"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.gramos_calculados_deterioro}
                    className="form-control"
                    placeholder="Gramos calculados deterioro"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="gramos_calculados_deterioro-error"
                  ></div>
                </div>
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-lg-12">
                <button
                  type="submit"
                  title="Agregar"
                  className="btn btn-success pull-right"
                >
                  <i className="fa fa-plus"></i>
                </button>
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-lg-12">
                <table className="table table-striped mb-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Principio activo</th>
                      <th className="text-center">Despacho</th>
                      <th className="text-center">Ingreso unidades</th>
                      <th className="text-center">Deterioro unidades</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center">prueba</td>
                      <td className="text-center">prueba</td>
                      <td className="text-center">prueba</td>
                      <td className="text-center">prueba</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr />

            <button
              type="button"
              onClick={this.props.rejectedAll}
              className="btn btn-danger pull-right ml-3"
            >
              Regresar
            </button>

            <button type="submit" className="btn btn-success pull-right">
              Guardar
            </button>

            {/* </div> */}
          </fieldset>
        </div>
      </>
    );
  }
}

export default ReportTwo;
